import {showErrorMessage, showSuccessMessage} from '@/helper';
import {refreshLoggedUser} from '@/services/AuthService';

export default {

    async sendRequirement(form) {
        const formData = new FormData();
        for (const key in form) {
            if (key === 'attachments') {
                form.attachments.forEach(attachment => {
                    formData.append('attachments[]', attachment);
                });
                continue;
            }
            formData.append(key, form[key]);
        }

        if (form.attachment) {
            formData.append('attachments', form.attachment);
        }
        return new Promise(function (resolve, reject) {
            http.post('api/service-requirements', formData, {headers: {
                    "Content-Type": "multipart/form-data",
                },})
                .then(response => {
                    showSuccessMessage('Požadavek byl úspěšně odeslán.');
                    refreshLoggedUser();
                    resolve(response.data);
                }, error => {
                    if (error.response?.data?.message) {
                        showErrorMessage(error.response.data.message);
                    }
                    reject(error);
                });
        });
    },

    getSettingsValueByKey(key) {
        return new Promise((resolve, reject) => {
            // _t cache buster zabraňuje prohlížeči/CDN servírovat zastaralou odpověď
            http.get('api/settings?key=' + key + '&_t=' + Date.now()).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    getOnboardingSettings() {
        return new Promise((resolve, reject) => {
            http.get('api/settings/onboarding').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    deleteSettingsDocumentsLogo() {
        return new Promise((resolve, reject) => {
            http.delete('api/settings/documents-logo').then(response => {
                resolve(response.data);
            }).catch(error => {
                showErrorMessage(error.response.data.message);
                //reject([]);
            });
        });
    },

    saveOnboardingSettings(data) {
        return new Promise((resolve, reject) => {
            http.post('api/settings', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }
}

